/**
 * Validates a shortcode's checkdigits
 * @param code The shortcode
 * @param checkdigits The checkdigits to validate (2 chars)
 * @returns true if valid, false otherwise
 */
export async function validateShortcodeCheckdigits(
  code: string,
  checkdigits: string
): Promise<boolean> {
  // Convert code to UTF-8 bytes and compute SHA-256
  const encoder = new TextEncoder();
  const data = encoder.encode(code);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);

  // Convert to hex string
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');

  // Take first 2 characters and uppercase
  const expectedCheckdigits = hashHex.substring(0, 2);

  return checkdigits.toUpperCase() === expectedCheckdigits.toUpperCase();
}
